import Tooltip from 'Components/Molecules/Tooltip/Tooltip';
import Icon from 'Components/Atoms/Icon/Icon';
import clsx from 'clsx';
import { formatCurrency } from 'Utils/formatters';
import { useTranslation } from 'react-i18next';
import useLocale from 'Hooks/useLocale';
import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';
import useCurrency from 'Hooks/useCurrency';
import IconButton from 'Components/Atoms/IconButton/IconButton';
import { REPLAY_BLOCK_CLASS } from 'Utils/constants';

export default function Amount(props) {
    const { amount, className, isExclude, onChangeExclude, isReverse, isIncome, isSplit, reverseTooltipLabel } = props;

    const { t } = useTranslation('common');
    const defaultLocale = useLocale();
    const defaultCurrency = useCurrency();

    const locale = props.locale || defaultLocale;
    const currency = props.currency || defaultCurrency;

    return (
        <div
            className={cn(
                'inline-flex gap-1 justify-end items-center relative w-fit ml-auto mr-0 text-sm text-dark-blue',
                className,
            )}
        >
            {typeof onChangeExclude === 'function' && (
                <div className="absolute -left-6.5 top-1/2 -translate-y-1/2">
                    <Tooltip
                        label={
                            <span className="text-capitalize font-normal text-xs">
                                {isExclude ? t('no-ignore') : t('ignore')}
                            </span>
                        }
                    >
                        <IconButton
                            variant="ghost"
                            iconSize={16}
                            size="small"
                            icon={<Icon name="ignore" />}
                            className={clsx(
                                'opacity-0 group-hover/row:opacity-100 [@media(hover:none)]:opacity-100 transition-opacity',
                                {
                                    ['opacity-100']: isExclude,
                                },
                            )}
                            onClick={(e) => {
                                e.stopPropagation();
                                onChangeExclude(!isExclude);
                            }}
                        />
                    </Tooltip>
                </div>
            )}

            {isReverse && (
                <Tooltip label={<span className="font-normal text-xs pb-[2px]">{reverseTooltipLabel}</span>}>
                    <div className={clsx('shrink-0 flex', isIncome && 'text-income')}>
                        <Icon name="reverse" size={12} color="currentColor" />
                    </div>
                </Tooltip>
            )}

            {isSplit && (
                <Tooltip label={<span className="font-normal text-xs">{t('divided')}</span>}>
                    <div className={clsx('shrink-0 flex', isIncome && 'text-income')}>
                        <Icon name="split" size={16} color="currentColor" />
                    </div>
                </Tooltip>
            )}

            <span
                className={clsx('whitespace-nowrap font-medium font-mono', REPLAY_BLOCK_CLASS, {
                    ['text-income']: isIncome,
                    ['opacity-50']: isExclude,
                })}
            >
                {formatCurrency(amount, { currency, locale })}
            </span>
        </div>
    );
}

Amount.propTypes = {
    amount: PropTypes.number,
    currency: PropTypes.string,
    className: PropTypes.string,
    locale: PropTypes.string,
    isExclude: PropTypes.bool,
    onChangeExclude: PropTypes.func,
    isReverse: PropTypes.bool,
    isIncome: PropTypes.bool,
    isSplit: PropTypes.bool,
    reverseTooltipLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
